// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main.btn.filled[data-v-3c9bbc2f]:hover{background-color:var(--color-darker-main)}.main.btn.filled[data-v-3c9bbc2f]{background-color:var(--color-main);color:var(--color-white);font-weight:600}", ""]);
// Exports
module.exports = exports;
